// extracted by mini-css-extract-plugin
module.exports = {"actionIcon":"NavbarButtonSupport_actionIcon__DXNex","icon":"NavbarButtonSupport_icon__fjwCn"};